<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Edit {{ title }}</p>
      <button type="button" class="delete" @click="$parent.close()" />
    </header>

    <section class="modal-card-body">
      <div v-if="image" class="pb-5">
        <Cropper
          classname="upload-example-cropper"
          :src="image"
          ref="cropper"
          :stencilProps="{ aspectRatio: 1 / 1 }"
        />
      </div>
      <div class="columns is-centered">
        <div class="column is-narrow">
          <div class="file">
            <label class="file-label">
              <input
                class="file-input"
                type="file"
                name="resume"
                ref="file"
                @change="uploadImage($event)"
                accept="image/*"
              />
              <span class="file-cta">
                <b-icon class="file-icon" icon="upload"></b-icon>
                <span class="file-label">Click to upload</span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </section>

    <footer class="modal-card-foot">
      <span class="card-footer-item">
        <b-button @click="$parent.close()"> Close </b-button>
      </span>

      <span v-if="image" class="card-footer-item">
        <b-button type="is-success" @click="updateImage"> Update </b-button>
      </span>
      <span v-else class="card-footer-item">
        <b-button disabled type="is-success" @click="updateImage"> Update </b-button>
      </span>
    </footer>
  </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import { mapGetters } from 'vuex'
export default {
  props: [ 'title', 'emitSignal' ],
  components: {
    Cropper
  },
  data () {
    return {
      image: null
    }
  },
  computed: {
    ...mapGetters({
      isOwner: 'isOwner',
      currentUser: 'currentUser'
    })
  },
  methods: {
    uploadImage (event) {
      let input = event.target
      if (input.files && input.files[0]) {
        let reader = new FileReader()
        reader.onload = (e) => {
          this.image = e.target.result
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    updateImage () {
      const { canvas } = this.$refs.cropper.getResult()
      this.$emit(this.emitSignal, canvas.toDataURL())
      this.$parent.close()
    }
  }
}
</script>

<style lang="css" scoped></style>
